module.exports = __webpack_public_path__ + "static/img/Vector 48.eaf6fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/Vector 48.png
// module id = SXiu
// module chunks = 1